import { contains, curry, partial, pluck } from "ramda";
import { findAppFromStoreByAppName } from "helpers/brand";
import type { AppLocation, IEntity, IEntityApp } from "interfaces/app";

const SUPERUSER_PERMISSION = "all";

export enum BREADCRUMB_PERMISSIONS {
  ROLE_ACCESS = "generalRoleAccess",
  USERS = "adminaccessUsers",
  VIEW_USERS_ROLES = "adminaccessViewUsersRoles",
  WORKFORCE = "workforceManageSchedules",
  MENU = "adminaccessMenues",
  VIEW_MENUS = "adminaccessViewMenus",
  REPORTS = "adminaccessReports",
}

export enum PARTNER_INTEGRATIONS {
  WORKFORCE = "upserveWorkforce",
}

export enum PARTNER_INTEGRATION_VALUES {
  ACTIVE = "Active",
  ARCHIVED = "Archived",
}

export const hasRequestedApp = (
  requestedApp: string,
  location: IEntity
): boolean => {
  requestedApp = requestedApp.toLowerCase();
  let correctedAppName = requestedApp === "upserve" ? "swipely" : requestedApp;
  if (correctedAppName.includes("workforce")) {
    correctedAppName = "workforce_scheduling";
  }
  const appNames = pluck<"name", string>("name", location.apps);
  return contains(correctedAppName, appNames);
};

export const locationHasAnalytics = partial(hasRequestedApp, ["swipely"]);
export const locationHasBreadcrumb = partial(hasRequestedApp, ["breadcrumb"]);
export const locationHasInventory = partial(hasRequestedApp, ["inventory"]);

export const hasAppPermission = (
  app: IEntityApp,
  permission: string
): boolean => {
  if (app && app.permissions) {
    if (app.permissions[SUPERUSER_PERMISSION]) {
      return true;
    } else if (app.permissions[permission] === true) {
      return true;
    }
  }
  return false;
};

export const hasAppPermissionAtStore = curry(
  (appName: AppLocation, permission: string, store: IEntity): boolean => {
    const app = findAppFromStoreByAppName(appName, store);
    return app ? hasAppPermission(app, permission) : false;
  }
);

export const hasBreadcrumbPermission = hasAppPermissionAtStore("breadcrumb");
export const hasAnalyticsPermission = hasAppPermissionAtStore("swipely");
export const hasInventoryPermission = hasAppPermissionAtStore("inventory");

export const hasPartnerIntegration = (
  store: IEntity,
  integration: PARTNER_INTEGRATIONS
): boolean => {
  return (
    store &&
    !!store.partnerIntegrations &&
    store.partnerIntegrations[integration] === PARTNER_INTEGRATION_VALUES.ACTIVE
  );
};
